
import * as THREE from "../../libs/three.js/build/three.module.js";

export class CurbReveal extends THREE.Object3D {

	constructor(camera) {
		super();

		this.constructor.counter = (this.constructor.counter === undefined) ? 0 : this.constructor.counter + 1;
		this.name = "curb_reveal_" + this.constructor.counter;

		// Capture camera state at creation time (ElevationZone pattern)
		this.camera = camera.clone();
		this.camera.rotation.set(...camera.rotation.toArray());
		this.camera.rotation.order = camera.rotation.order;
		this.camera.updateMatrixWorld();
		this.camera.updateProjectionMatrix();
		this.camera.matrixWorldInverse.copy(this.camera.matrixWorld).invert();
		this.viewMatrix = this.camera.matrixWorldInverse.clone();
		this.projMatrix = this.camera.projectionMatrix.clone();

		// User's line along the curb (the 2 clicks)
		this.userLine = { start: null, end: null };

		// Auto-generated transect perpendicular to user's line
		this.transectLine = { start: null, end: null };
		this.swathWidth = 0.3048; // meters (1 foot) — swath along the curb direction

		// Elevation profile along the perpendicular transect
		this.profilePoints = [];   // [{distanceAlong, elevation}] fine-binned
		this.profileSmoothed = []; // after Gaussian smoothing

		// Detected curb edge
		this.detectedEdge = null;  // {distanceAlong, topDist, bottomDist,
		                           //  curbElev, roadElev, revealMeters, maxGradient}

		// NDC positions of quad vertices [curbStart, curbEnd, roadEnd, roadStart]
		// Used by shader for jitter-free containment test
		this.ndcVertices = [];

		// World-space line endpoints (synthesized from detected edge)
		this.curbLine = { start: null, end: null };
		this.roadLine = { start: null, end: null };
		this.quadCorners = []; // world-space [curbStart, curbEnd, roadEnd, roadStart]

		// Computed results (compatibility with cross-section integration)
		this.revealData = [];
		this.revealRange = { min: 0, max: 0 };
		this.revealProfile = null; // Float32Array(256) of normalized [0,1] reveal values

		// Config
		this.bandWidth = 0.10;   // meters - band around each line
		this.numBins = 50;
		this.zTolerance = 0.30;  // meters - rejects points far from expected surface

		this.initialized = false;
	}
}
